import * as studentTypes from "Store/students/constants";

export const setStudentActionSpinner = (payload) => ({
  type: studentTypes.SET_STUDENT_ACTION_SPINNER,
  payload
});

export const handleDeleteMultipleItemsFromStudent = (
  payload: DeleteRequest,
  studentId
): studentTypes.IHandleDeleteMultipleItems => ({
  type: studentTypes.HANDLE_DELETE_MULTIPLE_ITEMS_FROM_STUDENT,
  payload,
  studentId
});

export const handleFetchStudentCalendarData = (
  payload: string
): studentTypes.IHandleFetchStudentCalendarData => ({
  type: studentTypes.HANDLE_FETCH_STUDENT_CALENDAR_DATA,
  payload
});

export const handleOpenSelectedItemDetails = (
  payload: OpenDetailsRequest
): studentTypes.IHandleOpenSelectedItemDetails => ({
  type: studentTypes.HANDLE_OPEN_SELECTED_ITEM_DETAILS,
  payload
});

export const handleFetchStudents = (): studentTypes.IHandleFetchStudents => ({
  type: studentTypes.HANDLE_FETCH_STUDENTS
});

export const handleFetchAllStudents = (): studentTypes.IHandleFetchAllStudents => ({
  type: studentTypes.HANDLE_FETCH_ALL_STUDENTS
});

export const handleManageStudentEnrollments = (
  payload: StudentEnrollmentsPayload
): studentTypes.IHandleManageStudentEnrollments => ({
  type: studentTypes.HANDLE_MANAGE_STUDENT_ENROLLMENTS,
  payload
});

export const handleUpdateStudentAccount = (
  payload: UpdateStudentAccount,
  source: UpdateSource
): studentTypes.IHandleUpdateStudentAccount => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT_ACCOUNT,
  payload,
  source
});

/**
 * @param: payload: studentID
 * */
export const fetchStudent = (payload: string): studentTypes.IHandleFetchStudent => ({
  type: studentTypes.HANDLE_FETCH_STUDENT,
  payload
});
export const handleAssignInstructorToStudent = (
  payload: AssignInstructorToStudent
): studentTypes.IHandleAssignInstructorToStudent => ({
  type: studentTypes.HANDLE_ASSIGN_INSTRUCTOR_TO_STUDENT,
  payload
});

export const handleArchiveStudents = (
  payload: ArchiveStudentsPayload
): studentTypes.IHandleArchiveStudents => ({
  type: studentTypes.HANDLE_ARCHIVE_STUDENTS,
  payload
});

export const handleUpdateStudentReport = (
  studentReport: StudentReport
): studentTypes.IHandleUpdateStudentReport => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT_TARGET_SCORE,
  payload: studentReport
});

export const handleUpdateStudentProfile = (
  studentProfile: UpdateStudentProfile,
  source: UpdateSource
): studentTypes.IHandleUpdateStudentProfile => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT_PROFILE,
  payload: studentProfile,
  source
});

export const handleFetchStudentsStatistics = (): studentTypes.IHandleFetchStudentsStatistics => ({
  type: studentTypes.HANDLE_FETCH_STUDENTS_STATISTICS
});

export const setStudentsStatistics = (
  payload: StudentStatistics
): studentTypes.ISetStudentsStatistics => ({
  type: studentTypes.SET_STUDENTS_STATISTICS,
  payload
});

export const setStudents = (payload: Student[]): studentTypes.ISetStudents => ({
  type: studentTypes.SET_STUDENTS,
  payload
});

export const getStudentSessions = (): studentTypes.IHandleFetchStudentSessions => ({
  type: studentTypes.HANDLE_FETCH_STUDENT_SESSIONS
});

export const setActiveStudent = (payload: Student): studentTypes.ISetActiveStudent => ({
  type: studentTypes.SET_ACTIVE_STUDENT,
  payload
});

export const handleUpdateStudentReportLocally = (
  report: StudentReport,
  studentId: string
): studentTypes.IHandleUpdateStudentReportLocally => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT_REPORT_LOCALLY,
  payload: { report, studentId }
});

export const handleSendStudentReport = (
  payload: StudentReportRequest
): studentTypes.IHandleSendStudentReport => ({
  type: studentTypes.HANDLE_SEND_STUDENT_REPORT,
  payload
});

/**
 * @params:
 * payload: studentId
 * */

export const handleFetchStudentReportPreview = (
  payload: string
): studentTypes.IFetchStudentReportPreview => ({
  type: studentTypes.HANDLE_FETCH_STUDENT_REPORT_PREVIEW,
  payload
});

export const setReportPreview = (payload: Blob): studentTypes.ISetStudentReportPreview => ({
  type: studentTypes.SET_STUDENT_REPORT_PREVIEW,
  payload
});

export const handleUpdateStudentActivation = (
  payload: UpdateStudentActivationPayload,
  source: "list" | "details" = "details"
): studentTypes.IHandleUpdateStudentActivation => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT_ACTIVATION,
  payload,
  source
});

export const setStudentSummary = (payload: StudentSummary): studentTypes.ISetStudentSummary => ({
  type: studentTypes.SET_STUDENT_SUMMARY,
  payload
});

export const setStudentSessions = (payload: Session[]): studentTypes.ISetStudentSessions => ({
  type: studentTypes.SET_STUDENT_SESSIONS,
  payload
});

export const handleCreateStudentSession = (
  payload: CreateStudentSessionsPayload
): studentTypes.IHandleCreateStudentSessions => ({
  type: studentTypes.HANDLE_CREATE_STUDENT_SESSIONS,
  payload
});

export const handleUpdateStudentSession = (
  payload: Partial<ISessionRequest>
): studentTypes.IHandleUpdateStudentSession => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT_SESSION,
  payload
});

export const addStudentToLocation = (
  payload: AddStudentLocationsPayload
): studentTypes.IHandleAddStudentToLocation => ({
  type: studentTypes.HANDLE_ADD_STUDENT_TO_LOCATION,
  payload
});

export const handleCreateNewStudent = (
  payload: FormDataUserProfile,
  target: "student" | "instructor" | "classroom" = "student"
): studentTypes.IHandleCreateNewStudent => ({
  type: studentTypes.HANDLE_CREATE_NEW_STUDENT,
  payload,
  target
});

export const handleUpdateStudent = (payload: UpdateStudent): studentTypes.IHandleUpdateStudent => ({
  type: studentTypes.HANDLE_UPDATE_STUDENT,
  payload
});

export const removeInstructorFromStudent = (
  payload: RemoveInstructorFromStudentPayload
): studentTypes.IHandleRemoveInstructorFromStudent => ({
  type: studentTypes.HANDLE_REMOVE_INSTRUCTOR_FROM_STUDENT,
  payload
});

export const handleDownloadStudentSyllabus = (
  body: DownloadStudentSyllabusApi
): studentTypes.IHandleDownloadStudentSyllabus => ({
  type: studentTypes.HANDLE_DOWNLOAD_STUDENT_SYLLABUS,
  payload: {
    body
  }
});
